import React from 'react';
import { commentsClassName } from './comments.style';

interface CommentsProps {
    children?: React.ReactNode;
    name?: string;
}

const Comments: React.FC<CommentsProps> = ({
    children,
    name
}) => children ? (
    <div className={ commentsClassName }>
        { name && <strong>{ name }: </strong> }
        { children }
    </div>
) : null;

export default Comments;
